import { CarouselStackedCards } from '@bumble/ui-kit';
import router from 'next/router';

export default function StackedCardsBox({ data }: { data: any }) {
  const {
    title,
    description,
    cardImages,
    ctaLink,
    ctaText,
    background,
    addressLine1,
    addressLine2,
    addressLine3,
  } = data || {};

  const cta = {
    text: ctaText,
    href: ctaLink,
    // eslint-disable-next-line id-blacklist, id-length
    onClick: (e: any) => {
      if (!ctaLink.includes('?share')) {
        return;
      }

      // eslint-disable-next-line id-blacklist
      e.preventDefault();
      // eslint-disable-next-line id-blacklist
      e.stopPropagation();
      router.push(`${router.asPath}?share=story`, undefined, {
        shallow: true,
      });
    },
  };

  const sanitisedCardImages = cardImages.map((image: any) => ({
    imageSrc: image?.responsiveImage?.src,
    imageAlt: image?.responsiveImage?.alt,
  }));

  const addressLines = [addressLine1, addressLine2, addressLine3].filter((line) => line !== null);

  return (
    <CarouselStackedCards
      cards={sanitisedCardImages}
      title={title}
      description={description}
      // @ts-ignore – cta.onClick receives event param but CarouselStackedCards type expects () => void; runtime behavior is correct
      cta={cta}
      background={background}
      appDownloadTexts={addressLines}
    />
  );
}
